<div class="file-row">
    <div class="file-row__content">
        <div class="file-row__content-icon">
            <img src="/assets/icons/download-green.svg" width="10" height="10" alt="Download">
        </div>
        <strong class="file-row__content-name" [title]="name">
            {{name}}
        </strong>
    </div>
    <div class="file-row__progress">
        <span nz-icon nzType="loading" *ngIf="status === statuses.PREPARING"></span>
        <ng-container *ngIf="status === statuses.DOWNLOADING">
            <nz-progress 
                [nzPercent]="progress" 
                nzType="circle" 
                [nzWidth]="20"
                [nzShowInfo]="false"
                [nzStrokeColor]="'#128983'"
                [nzStrokeWidth]="8"
            ></nz-progress>
        </ng-container>
        <ng-container *ngIf="status === statuses.SUCCESS">
            <img src="/assets/icons/download-success.svg" class="downloader-status-icon" width="20" height="20" alt="Success">
        </ng-container>
        <ng-container *ngIf="status === statuses.ERROR">
            <img src="/assets/icons/download-fail.svg" class="downloader-status-icon" width="20" height="20" alt="Success">
        </ng-container>
    </div>
</div>